import { render, staticRenderFns } from "./RevenueComparison.vue?vue&type=template&id=045e0a3a"
import script from "./RevenueComparison.vue?vue&type=script&lang=js"
export * from "./RevenueComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045e0a3a')) {
      api.createRecord('045e0a3a', component.options)
    } else {
      api.reload('045e0a3a', component.options)
    }
    module.hot.accept("./RevenueComparison.vue?vue&type=template&id=045e0a3a", function () {
      api.rerender('045e0a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/RevenueComparison.vue"
export default component.exports